import React from "react";
import createReactClass from "create-react-class";
import ModalPhotoViewer from "./modal_photo_viewer";

export default createReactClass({
  displayName: "Root",
  render() {
    if (this.props.isActive) {
      return (
        <div className="row" id="footer">
          <hr style={{ margin: "0px 10px", borderTop: "1px solid #fff" }} />
          <div id="created-date">
            <span>{this.props.photoUploadedDate}</span>
          </div>
          <div
            className="col-md-6 col-sm-6 col-xs-6"
            style={ModalPhotoViewer.styles.footerItemBox}
          >
            <i
              className="far fa-thumbs-up"
              aria-hidden="true"
              style={ModalPhotoViewer.styles.footerIcon}
            />
            <span style={ModalPhotoViewer.styles.footerText}> いいね！</span>
          </div>
          <div
            className="col-md-6 col-sm-6 col-xs-6"
            style={ModalPhotoViewer.styles.footerItemBox}
          >
            <i
              className="fas fa-comment"
              aria-hidden="true"
              style={ModalPhotoViewer.styles.footerIcon}
            />
            <span style={ModalPhotoViewer.styles.footerText}>
              {" "}
              コメントする
            </span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  },
});
